export const DEFAULT_LOCALE = process.env.APP_LOCALE || 'en';
export const DEFAULT_TMS_FORMAT = 'default';
export const DEFAULT_CURRENCY = 'EUR';
/**
 * This object literal returns different language codes/locale formats depending on its usage
 * and is based on the locale standard defined by Next.js
 *
 * tmsFormat is the format required by our Translations Management System (Transifex)
 * cmsFormat is the format required by our Content Management System (Contentstack)
 */
const LOCALES = {
    // COM - Customer portal only
    en: {
        tmsFormat: 'en_US',
        cmsFormat: 'en',
        intlFormat: 'en',
        region: 'en',
        iso3: 'com',
        langISO1: 'en',
    },
    // COM - all zones except customer portal
    'en-US': {
        tmsFormat: 'en_US',
        cmsFormat: 'en-us',
        intlFormat: 'en-US',
        region: 'en',
        iso3: 'com',
        langISO1: 'en',
    },
    // Germany
    'de-DE': {
        tmsFormat: 'de_DE',
        cmsFormat: 'de-de',
        intlFormat: 'de-DE',
        region: 'de',
        iso3: 'deu',
        langISO1: 'de',
    },
    // UK
    'en-GB': {
        tmsFormat: 'en_GB',
        cmsFormat: 'en-gb',
        intlFormat: 'en-GB',
        region: 'gb',
        iso3: 'gbr',
        langISO1: 'en',
    },
    // Ireland
    'en-IE': {
        tmsFormat: 'en_IE',
        cmsFormat: 'en-ie',
        intlFormat: 'en-IE',
        region: 'ie',
        iso3: 'irl',
        langISO1: 'en',
    },
    // Austria
    'de-AT': {
        tmsFormat: 'de_DE',
        cmsFormat: 'de-at',
        intlFormat: 'de-AT',
        region: 'at',
        iso3: 'aut',
        langISO1: 'de',
    },
    // France
    'fr-FR': {
        tmsFormat: 'fr_FR',
        cmsFormat: 'fr-fr',
        intlFormat: 'fr-FR',
        region: 'fr',
        iso3: 'fra',
        langISO1: 'fr',
    },
    // Spain
    'es-ES': {
        tmsFormat: 'es_ES',
        cmsFormat: 'es-es',
        intlFormat: 'es-ES',
        region: 'es',
        iso3: 'esp',
        langISO1: 'es',
    },
    // Netherlands
    'nl-NL': {
        tmsFormat: 'nl_NL',
        cmsFormat: 'nl-nl',
        intlFormat: 'nl-NL',
        region: 'nl',
        iso3: 'nld',
        langISO1: 'nl',
    },
    // Poland
    'pl-PL': {
        tmsFormat: 'pl_PL',
        cmsFormat: 'pl-pl',
        intlFormat: 'pl-PL',
        region: 'pl',
        iso3: 'pol',
        langISO1: 'pl',
    },
    // Finland
    'fi-FI': {
        tmsFormat: 'fi_FI',
        cmsFormat: 'fi-fi',
        intlFormat: 'fi-FI',
        region: 'fi',
        iso3: 'fin',
        langISO1: 'fi',
    },
};
export const COUNTRIES_ISO_3 = {
    AUT: 'AUT',
    DEU: 'DEU',
    ESP: 'ESP',
    FRA: 'FRA',
    GBR: 'GBR',
    IRL: 'IRL',
    NLD: 'NLD',
    POL: 'POL',
    FIN: 'FIN',
    USA: 'USA',
};
export const INTL_LOCALES = {
    COM: 'en',
    US: 'en-US',
    UK: 'en-GB',
    GERMANY: 'de-DE',
    IRELAND: 'en-IE',
    AUSTRIA: 'de-AT',
    FRANCE: 'fr-FR',
    SPAIN: 'es-ES',
    NETHERLANDS: 'nl-NL',
    POLAND: 'pl-PL',
    FINLAND: 'fi-FI',
};
export const FORMATTED_LOCALE = {
    en: 'en',
    'en-us': 'en-US',
    'de-de': 'de-DE',
    'en-gb': 'en-GB',
    'en-ie': 'en-IE',
    'es-es': 'es-ES',
    'nl-nl': 'nl-NL',
    'de-at': 'de-AT',
    'fr-fr': 'fr-FR',
    'pl-pl': 'pl-PL',
    'fi-fi': 'fi-FI',
};
export const DOMAIN_FOR_LOCALE = {
    en: 'raisin.com/en',
    'en-US': 'raisin.com/en',
    'de-DE': 'weltsparen.de',
    'en-GB': 'raisin.co.uk',
    'en-IE': 'raisin.ie',
    'es-ES': 'raisin.es',
    'nl-NL': 'raisin.nl',
    'de-AT': 'weltsparen.at',
    'fr-FR': 'raisin.fr',
    'pl-PL': 'raisin.com/pl-pl',
    'fi-FI': 'raisin.com/fi-pl',
};
const LOCALES_INFO = Object.fromEntries(Object.entries(LOCALES).map(([key, value]) => [key.toLowerCase(), Object.assign(Object.assign({}, value), { key })]));
export const getLocale = (locale) => {
    if (locale === 'default') {
        return LOCALES_INFO[DEFAULT_LOCALE.toLocaleLowerCase()];
    }
    return LOCALES_INFO[locale.toLowerCase()];
};
export const getLocales = () => Object.keys(LOCALES);
//# sourceMappingURL=i18n.js.map